<template>
  <v-container>
    <v-form ref="form">
      <v-row justify="center">
        <v-col cols="12" lg="8">
          Senha atual
          <v-text-field
            v-model="currentPassword"
            :type="showCurrentPassword ? 'text' : 'password'"
            solo
            flat
            dense
            placeholder="Digite aqui sua senha atual"
            @click:append="showCurrentPassword = !showCurrentPassword"
            autocomplete="new-password"
            class="custom-textfield mt-1"
            :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[
              () => $v.currentPassword.required || 'Campo obrigatório',
              () => $v.currentPassword.minLength || 'Mínimo de 6 caracteres'
            ]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="8">
          Nova senha
          <v-text-field
            v-model="newPassword"
            :type="showPassword ? 'text' : 'password'"
            solo
            flat
            dense
            placeholder="Digite aqui sua nova senha"
            @click:append="showPassword = !showPassword"
            autocomplete="new-password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            class="custom-textfield mt-1"
            :rules="[
              () => $v.newPassword.required || 'Campo obrigatório',
              () => $v.newPassword.minLength || 'Mínimo de 6 caracteres'
            ]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="8">
          Confirme sua senha
          <v-text-field
            v-model="confirmPassword"
            :type="showConfirPassword ? 'text' : 'password'"
            solo
            flat
            dense
            placeholder="Digite aqui sua nova senha novamente"
            @click:append="showConfirPassword = !showConfirPassword"
            autocomplete="new-password"
            :append-icon="showConfirPassword ? 'mdi-eye' : 'mdi-eye-off'"
            class="custom-textfield mt-1"
            :rules="[
              () => $v.confirmPassword.required || 'Campo obrigatório',
              () => $v.confirmPassword.sameAsPassword || 'Senhas não são iguais'
            ]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="8" class="text-center">
          <v-btn
            @click="submit"
            color="primary"
            class="secondary-font text-capitalize font-weight-bold py-7 mb-8"
            elevation="24"
            rounded
            x-large
            :loading="loading"
            >Continuar
            <v-spacer></v-spacer>
            <v-icon right>mdi-arrow-right-bold-circle-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import userService from '@/services/user'

export default {
  name: 'RedefinirSenhaForm',
  mixins: [validationMixin],
  validations: {
    currentPassword: {
      required,
      minLength: minLength(6)
    },
    newPassword: {
      required,
      minLength: minLength(6)
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs('newPassword')
    }
  },
  data() {
    return {
      currentPassword: null,
      newPassword: null,
      confirmPassword: null,
      showPassword: false,
      showConfirPassword: false,
      showCurrentPassword: false,
      loading: false
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true
          await userService.changePassword({ currentPassword: this.currentPassword, newPassword: this.newPassword })
          this.$showSuccessMessage('Senha atualizada com sucesso')
          this.$refs.form.reset()
        } catch ({ response }) {
          this.$showErrorMessage(response.data.message)
          this
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style></style>
